import React, { Fragment, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import classNames from 'classnames'
import Discount from '../Discount/Discount'
import BundleListItem from '../BundleListItem/BundleListItem'
import CounterContainer from 'src/containers/CounterContainer/CounterContainer'
import purchaseModalClasses from 'src/components/Modals/PurchaseModal/PurchaseModal.module.scss'
import CounterContainerShared from 'training-lane-booking-shared/containers/CounterContainerShared/CounterContainerShared'
import {
    getPendingPaymentRequestsByType,
    getTypeId
} from 'training-lane-booking-shared/utilities/functions'
import { roles } from 'training-lane-booking-shared/utilities/constants'

const PriceList = ({
    priceList,
    roleId = roles.member.id
}) => {
    const refRef = useRef(null)
    const tlcRef = useRef(null)
    const irRef = useRef(null)

    const targetType = useSelector(
        state => state.utils.modalState.purchase.props?.targetType
    )

    const cart = useSelector(
        state => state.cart.cart
    )

    useEffect(() => {
        if (!isEmpty(targetType)) {
            const scrollProps = {
                block: 'start',
                inline: 'center',
                behavior: 'smooth',
                alignToTop: false
            }

            if (targetType.category === 'reformer') {
                setTimeout(() => {
                    refRef.current?.scrollIntoView(scrollProps)
                }, 0)
            }

            if (targetType.id === getTypeId('tlc')) {
                setTimeout(() => {
                    tlcRef.current?.scrollIntoView(scrollProps)
                }, 0)
            }

            if (targetType.id !== 'tlc' && targetType.category === 'ir') {
                setTimeout(() => {
                    irRef.current?.scrollIntoView(scrollProps)
                }, 0)
            }
        }
    }, [targetType])

    const paymentRequests = useSelector(
        state => state.firestore.ordered.paymentRequests
    )

    const pendingPaymentRequestsByType =
        getPendingPaymentRequestsByType(paymentRequests)

    return (
        <>
            {
                priceList.map(({ typeId, itemType, credits, bundleList }, i) => {
                    let wrapperProps = {}

                    if (typeId === getTypeId('pr1')) {
                        wrapperProps.ref = refRef
                    }

                    if (typeId === getTypeId('tlc')) {
                        wrapperProps.ref = tlcRef
                    }

                    if (typeId === getTypeId('ir1')) {
                        wrapperProps.ref = irRef
                    }

                    const pendingPaymentRequestsCount =
                        pendingPaymentRequestsByType?.[typeId] ?? null

                    const counterPaddingTop = (() => {
                        let padding = 0

                        if (pendingPaymentRequestsCount) {
                            padding += 5
                        }

                        return padding
                    })()

                    return (
                        <Fragment key={typeId}>
                            <div key={typeId} {...wrapperProps} className={
                                classNames(
                                    'grid-wrapper',
                                    purchaseModalClasses.fullWidth
                                )
                            }>
                                <div style={{ paddingTop: counterPaddingTop }}>
                                    <CounterContainerShared
                                        onList
                                        CounterContainer={CounterContainer}
                                        credits={credits}
                                        type={itemType}
                                    />
                                </div>
                                <div className="col-11 align-left">
                                    {bundleList.map((bl, j) => {
                                        if (j === 0) {
                                            const { key, ...rest } = bl

                                            const props = {
                                                ...rest,
                                                cart,
                                                pendingPaymentRequestsCount
                                            }

                                            return (
                                                <BundleListItem
                                                    key={key}
                                                    {...props}
                                                />
                                            )
                                        }

                                        return null
                                    })}
                                </div>
                            </div>
                            {
                                i < (priceList.length-1) ? <hr /> : null
                            }
                        </Fragment>
                    )
                })
            }
            {
                roleId === roles.ambassador.id && <Discount />
            }
        </>
    )
}

export default PriceList
